var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useEffect, useMemo } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { socket } from "api";
import { fetchCoinsNew, calculateStats } from "api/coin-api";
import { userDataStore } from "store";
var SOCKET_EVENT = "prices:update";
var appendPriceTOChart = function (chartData, newPrice) {
    if (chartData.length === 0)
        return [{ date: new Date().toISOString(), price: newPrice }];
    var newChart = __spreadArray([], chartData, true);
    newChart[newChart.length - 1] = __assign(__assign({}, newChart[newChart.length - 1]), { price: newPrice });
    return newChart;
};
var useRealTimeCoins = function () {
    var queryClient = useQueryClient();
    var userBalances = userDataStore(function (state) { var _a; return (_a = state.user) === null || _a === void 0 ? void 0 : _a.coinBalances; });
    var queryKey = useMemo(function () { return ["coins", userBalances]; }, [userBalances]);
    var query = useQuery({
        queryKey: queryKey,
        staleTime: Infinity,
        queryFn: function () { return fetchCoinsNew(userBalances || []); },
    });
    useEffect(function () {
        var handlePriceUpdate = function (socketPayload) {
            queryClient.setQueryData(queryKey, function (oldCoinsArr) {
                if (!oldCoinsArr)
                    return oldCoinsArr;
                var socketPrices = socketPayload.reduce(function (acc, curr) {
                    acc[curr.symbol] = curr.price;
                    return acc;
                }, {});
                return oldCoinsArr.map(function (coin) {
                    var newPrice = socketPrices[coin.title] ||
                        socketPrices["W".concat(coin.title)] ||
                        socketPrices[coin.title.toUpperCase()];
                    if (newPrice !== undefined && newPrice !== coin.price) {
                        var updatedChart = appendPriceTOChart(coin.chartData, newPrice);
                        return __assign(__assign({}, coin), { prevPrice: coin.price, price: newPrice, chartData: updatedChart, stats: calculateStats(updatedChart, newPrice) });
                    }
                    return coin;
                });
            });
        };
        socket.on(SOCKET_EVENT, handlePriceUpdate);
        return function () {
            socket.off(SOCKET_EVENT, handlePriceUpdate);
        };
    }, [queryClient, queryKey]);
    return query;
};
export default useRealTimeCoins;
